/**
 * Push Service — web (#1642).
 *
 * Every method is a no-op and `isSupported` is false. #1642 is native only;
 * the web build shows the same unread rows and must not grow a permission
 * prompt or a device row because a shared component imported this.
 *
 * Deliberately NOT a thrown "not implemented": a shared screen that calls
 * `setBadgeCount` on both platforms should not need a `Platform.OS` guard
 * around it. The guard is here, once.
 */

import type {
  PushPermissionState,
  PushRegistrationPayload,
  PushService,
  PushTapEvent,
} from './pushService';

export const pushService: PushService = {
  isSupported: false,
  async requestPermission(): Promise<PushPermissionState> {
    return 'unavailable';
  },
  async checkPermission(): Promise<PushPermissionState> {
    return 'unavailable';
  },
  async getDeviceToken(): Promise<string | null> {
    return null;
  },
  async describeDevice(): Promise<Omit<PushRegistrationPayload, 'token'>> {
    // Unreachable in practice — nothing registers on web — but the shape has
    // to exist for the type, and `ios` is less surprising than a throw.
    return { platform: 'ios', bundleId: '' };
  },
  async setBadgeCount(): Promise<void> {
    // No badge on web.
  },
  onNotificationTap(_handler: (event: PushTapEvent) => void): () => void {
    return () => {};
  },
  async getInitialNotification(): Promise<PushTapEvent | null> {
    return null;
  },
};
